import { useEffect } from "react";
import { useSelector } from "react-redux";

export const useResourceListener = (room, callback, delay) => {
   const { udasSocket } = useSelector((store) => store?.portal?.udasSocket);

   useEffect(() => {
      if (!udasSocket) return;

      const handleRunCallback = (isSecondary) => {
         let fn = Array.isArray(callback) ? callback[0] : callback;
         let fnDelay = delay;

         if (isSecondary && Array.isArray(callback)) {
            fn = () => callback[1]?.();
         }

         fnDelay ? setTimeout(fn, fnDelay) : fn();
      };

      udasSocket.on(room, handleRunCallback);

      return () => udasSocket?.off(room, handleRunCallback);
   }, [udasSocket]);
};
